require('./hirePaymentMethod.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const { getTooltipOptions, getCardTypeHire } = require('utilities/cardsHelper');

// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKMessage } = require('commonsComponents/OKMessage');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ actions
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const revolvingActions = require('actions/cardRevolvingDocuments');
const hireCreditCardActions = require('actions/hireCreditCard');

// @ constants
const {
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE_INCREMENT_INTERVAL,
    CARD_PAYMENT_METHOD_VARIABLE_MAX_PERCENTAGE,
    CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE,
    CARD_PAYMENT_METHOD_VARIABLE,
    EURO_SYMBOL,
    OCULTO_ENVIRONMENT,
    PERCENTAGE_SYMBOL,
    PRODUCTION_ENVIRONMENT,
} = require('constants/index');

const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class HirePaymentMethod extends React.Component {
    static constants = {
        CALCULATION_TYPE_FIXED_FEE: 0,
        CALCULATION_TYPE_VARIABLE_FEE: 1,
        FRAME_BORDER: "0",
        SCROLLING: "no",
        TITLE: "título",
    }

    constructor(props) {
        super(props);
        this.handleSelectTypeOnChange = this.handleSelectTypeOnChange.bind(this);

        const { immHirePaymentMethod } = this.props;
        const isNumberPayment = typeof immHirePaymentMethod.get('value') !== 'string';
        const isTypeMethodUnique = immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_UNIQUE;


        this.state = {
            afiUrl: '',
            isShowInfoCC: isNumberPayment,
            isShowBottomCC: isNumberPayment || isTypeMethodUnique,
            tin: this.getTinValue(props.creditType,),
            tae: this.getTaeValue(props.creditType, 'aplazado_tae'),
            taeInit: this.getTaeValue(props.creditType, 'tae')
        }
    }

    componentDidMount() {
        const {
            handleTypeChange,
            isNerudaCard,
            immFlagBasedFeatures,
            setInneParams,
        } = this.props;

        if (isNerudaCard && !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)) {
            handleTypeChange(CARD_PAYMENT_METHOD_UNIQUE);
        }

        if (immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)) {
            const { tin, tae, taeInit } = this.state;
            setInneParams({
                tin,
                tae,
                taeInit
            });
            this.checkRevolving();
        }
    }

    componentDidUpdate(prevProps) {
        const { immHirePaymentMethod } = this.props;

        if (prevProps.immHirePaymentMethod.get('type') !== immHirePaymentMethod.get('type') ||
            prevProps.immHirePaymentMethod.get('value') !== immHirePaymentMethod.get('value')
        ) {
            const { immFlagBasedFeatures } = this.props;
            if (immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)) {
                this.checkRevolving();
            }
        }
    }

    checkRevolving = () => {
        const { immHirePaymentMethod } = this.props;
        const value = immHirePaymentMethod.get('value');
        const method = immHirePaymentMethod.get('type');
        const calculationType = this.getCalculationType(method);
        const isNumberPayment = typeof immHirePaymentMethod.get('value') !== 'string';
        const isTypeMethodUnique = immHirePaymentMethod.get('type') === CARD_PAYMENT_METHOD_UNIQUE;

        if (isNumberPayment && !isTypeMethodUnique) {
            const { requestAfiInformation, immHireCreditLimit } = this.props;
            const amount = immHireCreditLimit.get('creditLimit');
            this.setState({ afiUrl: this.buildAFISimulatorURL(calculationType, value) })
            requestAfiInformation(amount);
        }

        this.setState({
            isShowInfoCC: isNumberPayment,
            isShowBottomCC: isNumberPayment || isTypeMethodUnique
        });
    }

    handleDropdownChange = (valueObject) => {
        this.props.handleValueChange(valueObject.value);
    }

    generateSequence(first, last, increment) {//TODO: check if there's an ES6 function for this
        let numbers = [];
        let number = first;
        numbers.push(number);
        while ((number + increment) <= last) {
            number += increment;
            numbers.push(number);
        }

        return numbers;
    }

    generateDropdownOptions(percentage = false) {
        const { immCreditLimit, creditType } = this.props;
        const creditLimit = immCreditLimit.get('creditLimit');
        let increment;
        if (percentage) {
            increment = CARD_PAYMENT_METHOD_VARIABLE_INCREMENT_INTERVAL;
        } else {
            increment = ['diamond', 'premium'].includes(creditType) ? 150 : 15;
        }

        const first = percentage ? CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE : Math.ceil((0.05 * creditLimit) / increment) * increment;
        const last = percentage ? CARD_PAYMENT_METHOD_VARIABLE_MAX_PERCENTAGE : Math.floor((0.9 * creditLimit) / increment) * increment;
        const sequence = this.generateSequence(first, last, increment);

        return sequence.map(item => ({
            value: item,
            label: `${formatAmount(item, getLanguage(), 0)} ${percentage ? PERCENTAGE_SYMBOL : EURO_SYMBOL}`
        }));
    }

    buildDropdownElement() {
        const { immHirePaymentMethod } = this.props;
        const paymentMethodType = immHirePaymentMethod.get('type');
        const paymentMethodValue = immHirePaymentMethod.get('value');
        let dropdownElement;

        if (paymentMethodType !== CARD_PAYMENT_METHOD_UNIQUE) {
            let errorMsg;
            let label;
            let minPercentageText;
            let options;
            const errorMsgVisible = immHirePaymentMethod.get('valueIsDirty') && !immHirePaymentMethod.get('valueIsValid');

            switch (paymentMethodType) {
                case CARD_PAYMENT_METHOD_FIXED:
                    label = formatText('hirePaymentMethodComponent-fixedFeeDropdownTitle');
                    options = this.generateDropdownOptions();
                    errorMsg = formatText('hirePaymentMethodComponent-fixedFeeErrorMsg');
                    break;
                case CARD_PAYMENT_METHOD_VARIABLE:
                    options = this.generateDropdownOptions(true);
                    errorMsg = formatText('hirePaymentMethodComponent-variableFeeErrorMsg');
                    minPercentageText = (
                        <FormattedText
                            className="hire-payment-method__min-percentage-text"
                            injectedStrings={[CARD_PAYMENT_METHOD_VARIABLE_MIN_PERCENTAGE]}
                            value="hirePaymentMethodComponent-minPercentage"
                        />
                    );
                    break;
            }

            dropdownElement = (
                <div className="hire-payment-method__fee-input">
                    <OKSelect
                        label={label}
                        searchable={true}
                        options={options}
                        onChange={this.handleDropdownChange}
                        value={paymentMethodValue}
                        errorState={errorMsgVisible}
                        errorMessage={errorMsg}
                    />
                    {minPercentageText}
                </div>
            );
        }

        return dropdownElement;
    }

    getTinValue = (creditType) => {
        const {
            immGlobalVariables,
            revolvingPackId,
        } = this.props;

        const tinValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_tin']),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_tin']),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_tin']),
            'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_tin']),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_tin']),
        };

        return tinValues[creditType];
    }

    getTaeValue = (creditType, tae) => {
        const {
            immGlobalVariables,
            revolvingPackId,
        } = this.props;


        const taeValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', tae]),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', tae]),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', tae]),
            'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, tae]),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', tae]),
        };

        return taeValues[creditType];
    }

    getCalculationType = (method) => {
        if (method === CARD_PAYMENT_METHOD_FIXED) {
            return HirePaymentMethod.constants.CALCULATION_TYPE_FIXED_FEE
        } else if (method === CARD_PAYMENT_METHOD_VARIABLE) {
            return HirePaymentMethod.constants.CALCULATION_TYPE_VARIABLE_FEE
        }
    }

    buildAFISimulatorURL = (calculationType, value) => {
        const {
            immHireCreditLimit,
            setAFIParams
        } = this.props;
        const { tin } = this.state;

        const interestRate = Number(tin.replace(/%/g, '').replace(',', '.')) / 100;
        const amount = immHireCreditLimit.get('creditLimit');
        const paymentValueParamName = calculationType === HirePaymentMethod.constants.CALCULATION_TYPE_FIXED_FEE ? 'FixedPaymentAmount' : 'PercentagePaymentRate';
        const paymentValue = calculationType === HirePaymentMethod.constants.CALCULATION_TYPE_VARIABLE_FEE ? value / 100 : value;
        let urlParams = `?interestRate=${interestRate}&Amount=${amount}&CalculationType=${calculationType}&${paymentValueParamName}=${paymentValue}`;
        const language = getLanguage();

        if (language !== 'es') {
            urlParams += '&lang=en-US';
        }

        setAFIParams({
            interestRate,
            calculationType,
            typePayment: paymentValueParamName,
            valuePayment: paymentValue,
        });

        let url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRO');

        if (window.__ENV__ !== PRODUCTION_ENVIRONMENT && window.__ENV__ !== OCULTO_ENVIRONMENT) {
            url = formatText('hirePaymentMethodComponent-hirePaymentMethodComponent_AFISimulatorURLPRE');
        }

        return `${url}${urlParams}`;
    }

    buildInfoMessageCC() {
        const isRender = __CONTACT_CENTER__ && this.state.isShowInfoCC;

        return !!isRender && (
            <BlockInfo extraClass="cancel-bizum-step1__block-info">
                <p>
                    <b>
                        <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_TitleCC" />
                    </b>
                </p>
                <p>
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_ContentCC" />
                </p>
            </BlockInfo>
        )
    }

    buildBottomMessageCC() {
        const { immFlagBasedFeatures } = this.props;
        const showIneAndRevolving = immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
        const isRender = __CONTACT_CENTER__ && this.state.isShowBottomCC && showIneAndRevolving;

        return !!isRender && (
            <BlockInfo extraClass="cancel-bizum-step1__block-info">
                <span>
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_FotterInfoCC" />
                </span>
            </BlockInfo>
        )
    }

    buildMessageError() {
        return (
            <OKMessage type="warning">
                <div className="hire-payment-method__error-title">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorTitle" />
                </div>
                <div className="hire-payment-method__error-text">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorContent" />
                </div>
                <div className="hire-payment-method__error-text">
                    <FormattedText value="hirePaymentMethodComponent-hirePaymentMethodComponent_iframeErrorFooter" />
                </div>
            </OKMessage>
        )
    }

    buildSimulatorContent() {
        const {
            immHirePaymentMethod,
            immPdfRevolvingPersistent,
        } = this.props;

        const value = immHirePaymentMethod.get('value');
        const error = immPdfRevolvingPersistent.get('isIframeError');
        const success = immPdfRevolvingPersistent.get('isIframeSuccess');
        const loading = immPdfRevolvingPersistent.get('isIframeIsFetching');
        const { tin, tae, afiUrl } = this.state;

        if (!!value) {
            if (loading && !success) {
                return (<LoadingSection />)
            } else if (success) {
                return (
                    <React.Fragment>
                        <div className="hire-payment-method__simulator-iframe">
                            <iframe
                                src={afiUrl}
                                title={HirePaymentMethod.constants.FRAME_BORDER}
                                frameBorder={HirePaymentMethod.constants.SCROLLING}
                                scrolling={HirePaymentMethod.constants.TITLE}
                                className={'hire-payment-method__afi-iframe'}
                            />
                        </div>
                        <div className="hire-payment-method__payment-conditions">
                            <FormattedText
                                value="hirePaymentMethodComponent-hirePaymentMethodComponent_settlementMaxTime"
                            />
                            <FormattedText
                                value="hirePaymentMethodComponent-hirePaymentMethodComponent_interestType"
                                injectedStrings={[tin, tae]}
                            />
                        </div>
                    </React.Fragment>
                );
            } else if (error) {
                return this.buildMessageError();
            }
        }
        return null;
    }
    handleSelectTypeOnChange(type) {
        const {
            newSetCardLimit,
            newSetHireCreditCardType,
            handleTypeChange
        } = this.props;
        handleTypeChange(type)
        newSetCardLimit && newSetHireCreditCardType()
    }
    buildRadioButtons() {
        const {
            creditType,
            immFlagBasedFeatures,
            immHirePaymentMethod,
            isNerudaCard,
            showFullPay,
            newSetCardLimit,
        } = this.props;
        const paymentMethodType = immHirePaymentMethod.get('type');
        const tooltipKeys = {
            'open-credit': 'deferredTooltip',
            'diamond': 'deferredTooltipDiamondPremium',
            'premium': 'deferredTooltipDiamondPremium',
            'revolving': 'deferredTooltipRevolving',
            'viat': 'deferredTooltipVIAT'
        };

        const tooltipKey = tooltipKeys[creditType];

        let radioButtonElements;
        let radioButtonOptions = [
            {
                label: 'hirePaymentMethodComponent-optionDeferredFixedFee',
                showSimulator: immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS),
                tooltipContent: <FormattedText value={`hirePaymentMethodComponent-${tooltipKey}`} />,
                tooltipType: 'tooltipFixedPaymentShown',
                value: CARD_PAYMENT_METHOD_FIXED,
            },
            {
                label: 'hirePaymentMethodComponent-optionDeferredVariableFee',
                showSimulator: immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS),
                tooltipType: 'tooltipVariablePaymentShown',
                value: CARD_PAYMENT_METHOD_VARIABLE,
            }
        ];

        if (showFullPay) {
            radioButtonOptions.push({
                value: CARD_PAYMENT_METHOD_UNIQUE,
                label: 'hirePaymentMethodComponent-optionFullPay',
            });
        }

        if (isNerudaCard && !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)) {
            radioButtonOptions = [{
                value: CARD_PAYMENT_METHOD_UNIQUE,
                label: 'hirePaymentMethodComponent-optionFullPay',
            }];
        }

        radioButtonElements = radioButtonOptions.map((option, index) => {
            const isChecked = paymentMethodType === option.value;
            const hasTooltip = option.tooltipContent !== undefined;

            let label = <FormattedText value={option.label} />;
            let dropdownElement;
            let simulatorContent;
            let messageInfoContent = null;

            if (isChecked && (immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS) && isNerudaCard || !isNerudaCard)) {
                dropdownElement = this.buildDropdownElement();
                if (hasTooltip) {
                    const tooltipElement = this.buildTooltip(option.tooltipContent, option.tooltipType);
                    label = <div>{label}{tooltipElement}</div>;
                }

                if (option.showSimulator) {
                    simulatorContent = this.buildSimulatorContent();
                    messageInfoContent = this.buildInfoMessageCC();
                }
            }

            return (
                <div key={index}>
                    <RadioButton
                        className="block-step__radio"
                        id={`methodOfPayment${index}`}
                        isChecked={isChecked}
                        label={label}
                        onChange={this.handleSelectTypeOnChange}
                        value={option.value}
                    />
                    <div className="row">
                        <div className="col-xs-8 col-md-6">
                            {dropdownElement}
                        </div>
                    </div>
                    {messageInfoContent}
                    <div className="row">
                        {simulatorContent}
                    </div>
                </div>
            );
        });

        return radioButtonElements;
    }

    buildTooltip(tooltipContent, tooltipType) {
        const { setTooltipShown } = this.props;
        let tooltipElement;

        if (tooltipContent !== undefined) {
            tooltipElement = (
                <OKTooltip
                    content={tooltipContent}
                    offset={[0, -10]}
                    onHover={() => {
                        setTooltipShown(tooltipType);
                    }}
                    type="custom"
                />
            );
        }

        return tooltipElement;
    }

    buildMainLabelTooltip() {
        const {
            creditType,
            immGlobalVariables,
            revolvingPackId,
            showFullPay,
        } = this.props;

        const monthlyValues = {
            'open-credit': immGlobalVariables.getIn(['variables', 'parameters', 'open_credit', 'aplazado_mensual']),
            'diamond': immGlobalVariables.getIn(['variables', 'parameters', 'pack_diamond', 'aplazado_mensual']),
            'premium': immGlobalVariables.getIn(['variables', 'parameters', 'pack_premium', 'aplazado_mensual']),
            'revolving': immGlobalVariables.getIn(['variables', 'parameters', `revolving_pack_${revolvingPackId}`, 'aplazado_mensual']),
            'viat': immGlobalVariables.getIn(['variables', 'parameters', 'via-t', 'aplazado_mensual']),
        };

        const { tin, tae } = this.state;
        const monthly = monthlyValues[creditType];
        let extraText;

        if (showFullPay) {
            extraText = (
                <div>
                    <div className="hire-payment-method__tooltip-title">
                        <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsThirdLabel", getCardTypeHire(creditType))} />
                    </div>
                    <div className="hire-payment-method__tooltip-text">
                        <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsThirdText", getCardTypeHire(creditType))} />
                    </div>
                </div>
            );
        }

        return (
            <article className="hire-payment-method__tooltip">
                <div className="hire-payment-method__tooltip-title">
                    <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsFirstLabel", getCardTypeHire(creditType))} />
                </div>
                <div className="hire-payment-method__tooltip-text">
                    <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsFirstText", getCardTypeHire(creditType))} />
                </div>
                <div className="hire-payment-method__tooltip-title">
                    <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsSecondLabel", getCardTypeHire(creditType))} />
                </div>
                <div className="hire-payment-method__tooltip-text">
                    <FormattedText value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipOptionsSecondText", getCardTypeHire(creditType))} />
                </div>
                {extraText}
                <div className="hire-payment-method__tooltip-footnote">
                    <FormattedText
                        injectedStrings={[monthly, tin, tae]}
                        value={getTooltipOptions("cardChangeAndHirePaymentMethod-tooltipLastMessagePercentages", getCardTypeHire(creditType))}
                    />
                </div>
            </article>
        );
    }

    render() {
        const { immCreditLimit, immHirePaymentMethod } = this.props;
        const mainLabelTooltipContent = this.buildMainLabelTooltip();
        const mainLabelTooltip = this.buildTooltip(mainLabelTooltipContent, 'tooltipInfoShown');
        const radioButtonElements = this.buildRadioButtons();
        const typeErrorMsgVisible = immHirePaymentMethod.get('typeIsDirty') && !immHirePaymentMethod.get('typeIsValid');
        const typeErrorMsg = formatText('hirePaymentMethodComponent-typeErrorMsg');
        let content = null;

        if (!immCreditLimit.get('isFetching')) {
            content = (
                <article className="hire-payment-method row">
                    <div className="col-xs-12">
                        <FormattedText
                            className="hire-payment-method__header-label"
                            value="hirePaymentMethodComponent-title"
                        />
                        {mainLabelTooltip}
                        <RadioButtonGroup
                            name="selectMethodOfPayment"
                            idPrefix="selectMethodOfPayment"
                            errorState={typeErrorMsgVisible}
                            errorMessage={typeErrorMsg}
                        >
                            {radioButtonElements}
                        </RadioButtonGroup>
                        {this.buildBottomMessageCC()}
                    </div>
                </article>
            );
        }

        return content;
    }
}

HirePaymentMethod.defaultProps = {
    creditType: 'open-credit',
    isNerudaCard: false,
    showFullPay: true
}

HirePaymentMethod.propTypes = {
    creditType: PropTypes.oneOf(['open-credit', 'diamond', 'premium', 'revolving', 'viat']),
    handleTypeChange: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    immCreditLimit: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immHireCreditLimit: PropTypes.object,
    immHirePaymentMethod: PropTypes.object.isRequired,
    immPdfRevolvingPersistent: PropTypes.object,
    isNerudaCard: PropTypes.bool,
    revolvingPackId: PropTypes.number,
    requestAfiInformation: PropTypes.func,
    setAFIParams: PropTypes.func,
    setInneParams: PropTypes.func,
    setTooltipShown: PropTypes.func.isRequired,
    showFullPay: PropTypes.bool,
};

module.exports.constructor = HirePaymentMethod;

module.exports.HirePaymentMethod = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireCreditLimit: state.hireCreditLimit,
        immPdfRevolvingPersistent: state.revolvingPersistentData
    }),
    {
        setTooltipShown: hirePaymentMethodActions.setTooltipShown,
        handleTypeChange: hirePaymentMethodActions.setType,
        handleValueChange: hirePaymentMethodActions.setValue,
        requestAfiInformation: revolvingActions.requestAfiInformation,
        setAFIParams: revolvingActions.setAFIParams,
        setInneParams: revolvingActions.setInneParams,
        newSetHireCreditCardType: hireCreditCardActions.setHireCreditCardLimit,
    }
)(HirePaymentMethod);
